import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import data from './site-financial-status/site-financial-status';

const siteFinancialStatus = combineReducers({
  data,
  isLoading: loadingStatusAccordingToReducer('siteFinancialStatusLoadingStatus'),

});

export default siteFinancialStatus;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/site-financial-status.reducer.js